<template>
  <div>
    <canvas ref="compassCanvas" width="70" height="70"></canvas>
  </div>
</template>

<script>
export default {
  mounted() {
    //window.addEventListener("deviceorientation", this.handleOrientation);
    this.drawCompass(this.angleInDegrees);
  },
  unmounted() {
    //window.removeEventListener("deviceorientation", this.handleOrientation);
  },
  data() {
    return {
      //angleInDegrees: 0,
    };
  },
  props: {
    angleInDegrees: {
      type: Number,
      required: true,
    },
  },
  methods: {
    drawCompass(angle) {
      const canvas = this.$refs.compassCanvas;
      const ctx = canvas.getContext("2d");

      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 10;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw the outer circle
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
      ctx.strokeStyle = "black";
      ctx.stroke();

      // Draw the line indicating direction
      const angleInRadians = (angle - 90) * (Math.PI / 180); // Adjust for canvas rotation
      const lineEndX = centerX + radius * Math.cos(angleInRadians);
      const lineEndY = centerY + radius * Math.sin(angleInRadians);

      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(lineEndX, lineEndY);
      ctx.strokeStyle = "blue";
      ctx.lineWidth = 3;
      ctx.stroke();
    },

    // handleOrientation(event) {
    //   const alpha = event.alpha || 0; // Angle in degrees
    //   this.angleInDegrees = alpha; // Adjust for canvas rotation
    //   this.drawCompass(this.angleInDegrees);
    // },
  },
  watch: {
    angleInDegrees(newAngle) {
      this.drawCompass(newAngle); // Redraw when angle changes
    },
   },
};
</script>

<style>
canvas {
  border: 1px solid black;
}
</style>
